import { Alert, Box, Typography } from '@mui/material'
import {
  Create,
  required,
  SimpleForm,
  TextInput,
  useGetIdentity,
  useNotify,
  usePermissions,
  useRedirect,
  useTranslate,
} from 'react-admin'

const GroupCreate = () => {
  const notify = useNotify()
  const redirect = useRedirect()
  const translate = useTranslate()
  const { identity, isLoading: identityLoading } = useGetIdentity()
  const { permissions, isLoading: permissionsLoading } = usePermissions()

  // Only vetadmin can create groups
  const canCreate = permissions?.role === 'vetadmin'
  const isLoading = identityLoading || permissionsLoading

  const onSuccess = () => {
    notify('resources.groups.notifications.created', { type: 'success' })
    redirect('list', 'groups')
  }

  const onError = (error: any) => {
    console.error('Group creation error:', error)
    // Check for specific error types
    if (error?.status === 403) {
      notify('resources.groups.errors.forbidden', { type: 'error' })
    } else {
      notify('resources.groups.errors.create_failed', { type: 'error' })
    }
  }

  // Transform the data before submission to include the current user as admin
  const transform = (data: any) => {
    return {
      ...data,
      admins: identity?.id ? [identity.id] : [],
    }
  }

  // Show loading state while checking permissions
  if (isLoading) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography>{translate('ra.page.loading')}</Typography>
      </Box>
    )
  }

  // Block access for non-vetadmin users
  if (!canCreate) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">{translate('resources.groups.errors.no_create_permission')}</Alert>
      </Box>
    )
  }

  return (
    <Create redirect="list" transform={transform} mutationOptions={{ onSuccess, onError }}>
      <SimpleForm>
        <TextInput
          source="name"
          validate={required()}
          fullWidth
          helperText={translate('resources.groups.fields.name_helper')}
        />
        <TextInput
          source="description"
          multiline
          rows={3}
          fullWidth
          helperText={translate('resources.groups.fields.description_helper')}
        />
      </SimpleForm>
    </Create>
  )
}

export default GroupCreate
